interface CarouselItem {
  image: string;
  alt: string;
  tag: string;
  title: string;
  summary: string;
  meta: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20illustration%20with%20warm%20orange%20coral%20tones%2C%20celebrity%20silhouettes%20with%20mysterious%20atmosphere%2C%20social%20media%20style%20composition%20with%20speech%20bubbles%2C%20modern%20flat%20design%2C%20light%20cream%20background%2C%20editorial%20illustration%20style%2C%20clean%20minimal%20aesthetic&width=600&height=400&seq=carousel-melon-01&orientation=landscape',
    alt: '年度十大娱乐圈翻车事件盘点',
    tag: '焦点专题',
    title: '年度十大娱乐圈翻车事件大盘点',
    summary: '从明星人设崩塌到综艺现场翻车，今年娱乐圈的翻车名场面一个比一个精彩。每日大瓜为你整理了年度十大翻车事件，准备好你的小板凳，一起回顾这些让人目瞪口呆的瞬间。',
    meta: '12 个事件 · 45 万次阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20internet%20gossip%20culture%20illustration%2C%20social%20media%20influencer%20collapse%20theme%2C%20warm%20coral%20and%20peach%20tones%2C%20abstract%20geometric%20shapes%2C%20mysterious%20vibe%2C%20modern%20flat%20design%20art%2C%20clean%20cream%20background%2C%20editorial%20compositi&width=600&height=400&seq=carousel-melon-02&orientation=landscape',
    alt: '网红经济泡沫破裂全记录',
    tag: '深度专题',
    title: '网红经济泡沫破裂：从千万粉丝到无人问津',
    summary: '2024 年以来多位千万级网红接连翻车，从偷税漏税到人设崩塌，网红经济正经历前所未有的信任危机。每日大瓜为你梳理这场"网红大逃杀"的时间线与深层原因。',
    meta: '8 位网红 · 67 万次阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20reality%20TV%20illustration%2C%20stage%20theme%20with%20dramatic%20lighting%2C%20warm%20orange%20peach%20gradient%20tones%2C%20abstract%20performance%20elements%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20minimalist%20composition&width=600&height=400&seq=carousel-melon-03&orientation=landscape',
    alt: '选秀节目不为人知的幕后故事',
    tag: '独家专题',
    title: '选秀节目幕后全揭秘：那些不为人知的行业规则',
    summary: '从海选到总决赛，选秀节目背后有多少不为人知的秘密？每日大瓜根据多位业内人士爆料，揭示了选秀产业链中投票造假、导师暗箱操作、练习生压榨等现象。',
    meta: '6 个节目 · 89 万次阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20relationship%20illustration%2C%20mysterious%20romantic%20vibe%2C%20warm%20coral%20peach%20gradient%20tones%2C%20abstract%20silhouettes%2C%20modern%20flat%20design%20art%2C%20clean%20cream%20background%2C%20editorial%20composition%2C%20soft%20minimalist%20aesthetic&width=600&height=400&seq=carousel-melon-04&orientation=landscape',
    alt: '娱乐圈明星夫妻关系现状全扫描',
    tag: '热门专题',
    title: '娱乐圈明星夫妻关系现状：有人甜蜜有人离',
    summary: '明星夫妻的真实感情状况一直是吃瓜群众最关心的话题。每日大瓜整理了过去一年中 15 对明星夫妻的关系变化，从官宣离婚到低调复合，带你全面了解圈内婚恋生态。',
    meta: '15 对夫妻 · 112 万次阅读',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">
            深度梳理热门吃瓜话题，一文看懂事件全貌
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-accent-300/60 transition-colors"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">
                  <strong>{item.title}</strong>
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.summary}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.meta}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}